import selectOption from '@/store/dict/selectOptionDict'

export default function () {
  return {
    paymentInfoHeader: [
      {
        name: 'id',
        columnProps: {
          prop: 'id',
          label: '应付ID',
        },
      },
      {
        name: 'plateNo',
        columnProps: {
          prop: 'plateNo',
          label: '车牌号',
          width: 100,
        },
      },
      {
        name: 'contentName',
        columnProps: {
          prop: 'contentName',
          label: '支付内容',
        },
      },
      {
        name: 'payDate',
        columnProps: {
          prop: 'payDate',
          label: '应付日期',
        },
      },
      {
        name: 'payAmount',
        columnProps: {
          prop: 'payAmount',
          label: '应付金额',
        },
        getText: ({ row }) => this.numberWithCommas(row.payAmount),
      },
      {
        name: 'paidAmount',
        columnProps: {
          prop: 'paidAmount',
          label: '已付金额',
        },
        getText: ({ row }) => this.numberWithCommas(row.paidAmount),
      },
      {
        name: 'remarks',
        columnProps: {
          prop: 'remarks',
          label: '备注',
        },
      },
      {
        name: 'payState',
        columnProps: {
          prop: 'payState',
          label: '付款状态',
        },
        getText: ({ row }) => selectOption.paymentStatusDict[row.payState],
      },
      {
        name: 'completeTime',
        columnProps: {
          prop: 'completeTime',
          label: '付款完成时间',
        },
      },
    ],
    payfeeInfoHeader: [
      {
        name: 'id',
        columnProps: {
          prop: 'id',
          label: '应收ID',
        },
      },
      {
        name: 'plateNo',
        columnProps: {
          prop: 'plateNo',
          label: '车牌号',
          width: 100,
        },
      },
      {
        name: 'contentName',
        columnProps: {
          prop: 'contentName',
          label: '支付内容',
        },
      },
      {
        name: 'receivableDate',
        columnProps: {
          prop: 'receivableDate',
          label: '应收日期',
        },
      },
      {
        name: 'receivableAmount',
        columnProps: {
          prop: 'receivableAmount',
          label: '应收金额',
        },
        getText: ({ row }) => this.numberWithCommas(row.receivableAmount),
      },
      {
        name: 'receivedAmount',
        columnProps: {
          prop: 'receivedAmount',
          label: '已收金额',
        },
        getText: ({ row }) => this.numberWithCommas(row.receivedAmount),
      },
      {
        name: 'remarks',
        columnProps: {
          prop: 'remarks',
          label: '备注',
        },
      },
      {
        name: 'receivableState',
        columnProps: {
          prop: 'receivableState',
          label: '收款状态',
        },
        getText: ({ row }) => selectOption.completionStatusDict[row.receivableState],
      },
      {
        name: 'completeTime',
        columnProps: {
          prop: 'completeTime',
          label: '收款完成时间',
        },
      },
    ],
  }
}
